import {
    Autocomplete, Box, FormControlLabel, IconButton, Radio, RadioGroup, Table, TableBody, TableCell,
    TableHead, TableRow, TextField, Tooltip, Typography, Accordion, AccordionSummary, AccordionDetails
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import { COMMON_STYLE, Intensity_Level } from '../../../../Utility/Constants';
import DeleteIcon from '@mui/icons-material/Delete';
import ShowComponents from '../../DoctorNotes/Common/ShowComponent';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { useDebounce } from '../../../../Components/Common Components/CommonComponents';
import PrintIcon from '@mui/icons-material/Print';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


const investState = {
    patientId: '',
    appointmentId: '',
    clinicId: '',
    doctorId: '',
    investigationData: [],
    selectedRadio: 'test',
    labList: [],
    labTestData: [],
    specialData: [],
    selectedLabName: null,
    printLoad: false,
    dupInvestogationData: '[]'
}

const UmaInvestigationNew = React.forwardRef((props, ref) => {
    const [invest, setInvest] = useState(investState)
    const [search, setSearch] = useState('')
    const debounceQuery = useDebounce(search, 500)
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })

    React.useImperativeHandle(ref, () => ({
        performInvestigationAction: () => {
            let investData = JSON.stringify(invest.investigationData)
            if (investData !== invest.dupInvestogationData) {
                postInvestigationData()
            }
        }
    }))

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: `${message} - INVESTIGATION`,
        })
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: `${message} - INVESTIGATION`,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    useEffect(async () => {
        if (debounceQuery) {
            await getSpecialTestSearch(debounceQuery)
        } else {
            setInvest((prev) => ({
                ...prev, specialData: []
            }))
        }
    }, [debounceQuery])

    useEffect(() => {
        if (invest.printLoad) {
            getInvestigationPrint()
        }
    }, [invest.printLoad])

    const apicalls = async () => {
        await getLabTestData()
        await getInvestigationData()
    }

    const getLabTestData = async () => {
        try {
            const response = await RestAPIService.getAll(Serviceurls.DOC_TEST_LABTEST + '?clinic_id=' + props?.props?.clinic_id + '&doctor_id=' + props?.props?.doctorID)
            if (response?.data?.status === 'success') {
                let dataList = response?.data?.data
                setInvest((prev) => ({
                    ...prev,
                    labTestData: dataList
                }))
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error?.response?.data?.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const getSpecialTestSearch = async (search) => {
        try {
            const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_INVESTIGATION_SPECIAL_SEARCH + '?search=' + search + '&doctor_id=' + props?.props?.doctorID)

            if (response?.data?.status === 'success') {
                setInvest((prev) => ({
                    ...prev,
                    specialData: response?.data?.data
                }))
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error?.response?.data?.message)
            } else {
                errorMessage(error.message)
            }
        }
    }


    const getInvestigationData = async () => {
        try {
            const response = await RestAPIService.getAll(Serviceurls.DOC_TEST_GET +
                '?appointment_id=' + props?.props?.appointment_id + '&patient_id=' + props?.props?.patient_id + '&doctor_id=' + props?.props?.doctorID
            )
            if (response?.data?.status === 'success') {
                let responseData = response?.data?.data
                let investData = [];
                responseData?.forEach(element => {
                    investData?.push({
                        id: element?.id,
                        tst_name: element?.service_name || element?.special_test_name || element?.lab_test_names || element?.lab_set_names || element?.package_name,
                        grp_id: element?.lab_set_ids,
                        test_id: element?.lab_test_ids,
                        service_code: element?.service_code || '',
                        service_name: element?.service_name,
                        service_head_id: element?.service_head_id,
                        head_name: element?.service_head,
                        head_code: '',
                        service_details_id: element?.service_details_id,
                        test_name: element?.lab_test_names,
                        service_charge_id: element?.service_charge_id,
                        status: element?.status || 'Inprogress',
                        spl_id: element?.special_test_id,
                        transmitted_laboratory_id: element?.transmitted_laboratory_id,
                        transmitted_radiology_id: element?.transmitted_radiology_id,
                        type: element?.type,
                        op_order_line_id: element?.op_order_line_id,
                        is_transmitted: element?.is_transmitted,
                        test_type: element?.grp_id ? 'Group' : element?.package_id ? 'Package' : element?.special_test_id ? 'Special' : 'Test',
                        package_id: element?.package_id,
                        package_amount: element?.package_amount,
                        package_code: element?.package_code,
                        package_name: element?.package_name
                    })
                })
                let obj = {
                    tst_name: '', test_type: '', grp_id: null, head_code: '', head_name: '', service_charge_id: null, service_code: '',
                    service_details_id: null, service_head_id: null, service_name: '', test_id: null, test_name: '',
                    package_name: '', package_code: '', package_amount: '', package_id: null, spl_id: null, id: null,
                    status: 'Inprogress', is_transmitted: false
                }
                setInvest((prev) => ({
                    ...prev,
                    investigationData: responseData?.length ? [...investData, obj] : [obj],
                    dupInvestogationData: responseData?.length ? JSON.stringify([...investData, obj]) : JSON.stringify([obj])
                }))
                props.setAccordionOpen(investData?.length > 0);
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error?.response?.data?.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const getInvestigationPrint = async () => {
        try {
            const response = await RestAPIService.getAllPrint(Serviceurls.New_DOCTOR_NOTES_PRINT +
                '?appointment_id=' + props?.props?.appointment_id + '&patient_id=' + props?.props?.patient_id + '&export_type=pdf' + '&doctor_id=' + props?.props?.doctorID
            )
            if (response) {
                const file = new Blob(
                    [response.data],
                    { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
                setInvest((prev) => ({ ...prev, printLoad: false }))
            }
        } catch (error) {
            setInvest((prev) => ({ ...prev, printLoad: false }))
            if (error?.response?.data?.message) {
                errorMessage(error.response?.data?.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const postInvestigationData = async () => {
        try {
            let investigationList = []; let specialTest = []
            invest?.investigationData?.forEach(element => {
                if (element.test_type === 'Special') {
                    specialTest?.push({
                        id: element?.spl_id,
                        name: element?.tst_name
                    })
                } else if (element.test_type === 'Test' || element?.test_type === 'Group' || element?.test_type === 'Package') {
                    investigationList?.push({
                        grp_id: element?.grp_id,
                        head_code: element?.head_code,
                        head_name: element?.head_name,
                        service_charge_id: element?.service_charge_id,
                        service_code: element?.service_code,
                        service_details_id: element?.service_details_id,
                        service_head_id: element?.service_head_id,
                        service_name: element?.service_name,
                        test_id: element?.test_id,
                        test_name: element?.test_name,
                        is_transmitted: element?.is_transmitted,
                        package_amount: element?.package_amount,
                        package_code: element?.package_code,
                        package_id: element?.package_id,
                        package_name: element?.package_name,
                        id: element?.id ? element?.id : null
                    })
                }
            })
            let data = {
                appointment_id: props?.props?.appointment_id,
                lab_tests: investigationList,
                patient_id: props?.props?.patient_id,
                radiology_service: [],
                special_tests: specialTest
            }
            const response = await RestAPIService.create(data, Serviceurls.DOC_TEST_POST)
            if (response?.data?.status === 'success') {
                successMessage(response.data?.message)
                setInvest((prev) => ({ ...prev, selectedRadio: 'test' }))
                await getInvestigationData()
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error?.response?.data?.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const postInvestigationTransmitData = async () => {
        try {
            let transmitData = [];
            let data = {
                appointment_id: props?.props?.appointment_id,
                patient_id: props.props?.patient_id,
                line_item_ids: invest.investigationData.filter(item => item?.tst_name !== '')
            }
            const response = await RestAPIService.create(data, Serviceurls.TEST_TRANSMIT)
            if (response?.data?.status === 'success') {
                successMessage(response?.data?.message)
                setInvest((prev) => ({ ...prev, selectedRadio: 'test' }))
                await getInvestigationData()
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error?.response?.data?.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const deleteInvestigationData = async (item, index) => {
        try {
            if (item.id) {
                let data = { tests_id: item?.id, appointment_id: props?.props?.appointment_id, doctor_id: props?.props?.doctorID }
                const response = await RestAPIService.create(data,Serviceurls.DOC_TEST_GET )
                if (response.data.status === 'success') {
                    successMessage(response.data.message)
                    await getInvestigationData()
                }
            } else {
                let investigationData = [...invest.investigationData]
                setInvest((prev) => {
                    if (index !== (invest.investigationData?.length - 1)) {
                        investigationData?.splice(index, 1)
                    } else {
                        investigationData[index] = {
                            tst_name: '',
                            test_type: '',
                            grp_id: null,
                            head_code: '',
                            head_name: '',
                            service_charge_id: null,
                            service_code: '',
                            service_details_id: null,
                            service_head_id: null,
                            service_name: '',
                            test_id: null,
                            test_name: '',
                            package_name: '',
                            package_code: '',
                            package_amount: '',
                            package_id: null,
                            spl_id: null,
                            id: null,
                            status: 'Inprogress',
                            is_transmitted: false
                        }
                    }
                    return { ...prev, investigationData }
                })
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error?.response?.data?.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const onChangeHandler = (newValue, key, index) => {
        try {
            let investigation = [...invest.investigationData];
            switch (key) {
                case 'lab_name':
                    investigation[index] = {
                        ...investigation[index],
                        lab_name: newValue?.laboratory_name || '',
                        lab_id: newValue?.laboratory_id || ''
                    };
                    setInvest((prev) => ({ ...prev, investigationData: investigation, labTestData: newValue?.test_detail || [] }))
                    break;
                case 'test_name':
                    investigation[index] = {
                        ...investigation[index],
                        tst_name: newValue?.service_name || newValue?.package_name || '',
                        test_type: newValue?.grp_id ? 'Group' : newValue?.package_id ? 'Package' : 'Test',
                        grp_id: newValue?.grp_id || null,
                        head_code: newValue?.head_code || '',
                        head_name: newValue?.head_name || '',
                        service_charge_id: newValue?.service_charge_id || null,
                        service_code: newValue?.service_code || '',
                        service_details_id: newValue?.service_details_id || null,
                        service_head_id: newValue?.service_head_id || null,
                        service_name: newValue?.service_name || '',
                        test_id: newValue?.test_id || null,
                        test_name: newValue?.test_name || '',
                        package_name: newValue?.package_name || '',
                        package_code: newValue?.package_code || '',
                        package_amount: newValue?.package_amount || '',
                        package_id: newValue?.package_id || null,
                        spl_id: null,
                        is_transmitted: newValue?.is_transmitted || false
                    };
                    if (newValue && index === investigation.length - 1) {
                        investigation.push({
                            tst_name: '',
                            test_type: '',
                            grp_id: null,
                            head_code: '',
                            head_name: '',
                            service_charge_id: null,
                            service_code: '',
                            service_details_id: null,
                            service_head_id: null,
                            service_name: '',
                            test_id: null,
                            test_name: '',
                            package_name: '',
                            package_code: '',
                            package_amount: '',
                            package_id: null,
                            spl_id: null,
                            id: null,
                            status: 'Inprogress',
                            is_transmitted: false
                        });
                    }
                    setInvest((prev) => ({ ...prev, investigationData: investigation }))
                    break;
                case 'special_test_name':
                    investigation[index] = {
                        ...investigation[index],
                        tst_name: newValue?.name || newValue || '',
                        test_type: 'Special' || '',
                        spl_id: newValue?.id || null,
                        grp_id: null,
                        head_code: '',
                        head_name: '',
                        service_charge_id: null,
                        service_code: '',
                        service_details_id: null,
                        service_head_id: null,
                        service_name: '',
                        test_id: null,
                        test_name: '',
                        package_name: '',
                        package_code: '',
                        package_amount: '',
                        package_id: null,
                        is_transmitted: false
                    };
                    if (newValue && index === investigation.length - 1) {
                        investigation.push({
                            tst_name: '',
                            test_type: '',
                            grp_id: null,
                            head_code: '',
                            head_name: '',
                            service_charge_id: null,
                            service_code: '',
                            service_details_id: null,
                            service_head_id: null,
                            service_name: '',
                            test_id: null,
                            test_name: '',
                            package_name: '',
                            package_code: '',
                            package_amount: '',
                            package_id: null,
                            spl_id: null,
                            id: null,
                            status: 'Inprogress',
                            is_transmitted: false
                        });
                    }
                    setInvest((prev) => ({ ...prev, investigationData: investigation, specialData: [] }))
                    break;
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }


    const autocompleteTextBox = (names, values, options = [], optionLabel, placeholders, index) => {
        try {
            return (
                <Autocomplete
                    disabled={props?.props?.patient_transfered || props?.props?.isLocked || invest.investigationData[index]['is_transmitted'] || props?.props?.isOPtometry}
                    clearIcon
                    freeSolo={invest.selectedRadio === 'special' ? true : false}
                    size='small'
                    sx={{ width: '17dvw' }}
                    value={values}
                    options={options}
                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option[optionLabel]}
                    onChange={(e, newValue) => { onChangeHandler(newValue, names, index) }}
                    onInputChange={(e, newValue) => {
                        if (invest.selectedRadio === 'special') {
                            onChangeHandler(newValue, names, index)
                        }
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder={placeholders}
                            InputProps={{
                                ...params.InputProps, emed_tid: names,
                                style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                            }}
                            onChange={(e) => {
                                let value = e.target.value
                                if (invest.selectedRadio === 'special') {
                                    setSearch(value)
                                }
                            }}
                        />
                    )}
                    renderOption={(props, option) => (
                        <Box
                            component="li"
                            {...props}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                justifyContent: "flex-start",
                                width: "100%",
                                textAlign: "left",
                            }}
                        >
                            <Typography fontSize=".9vw" sx={{ width: "100%", textAlign: "left" }} >
                                {option?.service_name || option?.package_name || option?.tst_name || option?.name || "-"}
                            </Typography>
                            <Typography
                                fontSize=".8vw"
                                fontWeight="bold"
                                sx={{ width: "100%", textAlign: "left" }}
                                color={
                                    option?.test_id
                                        ? "#F1584A"
                                        : option?.grp_id
                                            ? "#29B6F6"
                                            : option?.package_id
                                                ? "#1E972A" :
                                                option?.id ?
                                                    'green' : "inherit"
                                }
                            >
                                {option?.test_id
                                    ? "Test"
                                    : option?.grp_id
                                        ? "Group Test"
                                        : option?.package_id
                                            ? "Package"
                                            : option?.id ? 'Special' : ""}
                            </Typography>
                        </Box>
                    )}
                />
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    return (
        <ShowComponents onIntersection={apicalls}>
            <Box component={'div'}>
                <Accordion expanded={props.accordionOpen}
                    onChange={(_, isExpanded) => {
                        props.setAccordionOpen(isExpanded, true);
                    }}>
                    <AccordionSummary className='doc_notes_header_card' expandIcon={<ExpandMoreIcon />}>
                    <Box component={'div'} className='doc_notes_header_card' display={'flex'} justifyContent={'space-between'} width={"100%"}>
                        <Typography className='doc_notes_header_card_font'>Investigation</Typography>
                        <Box component={'div'} display={'flex'}>
                            <RadioGroup
                                emed_tid='radio'
                                row
                                value={invest.selectedRadio}
                                onClick={(e) => e.stopPropagation()}
                                onMouseDown={(e) => e.stopPropagation()}
                                onChange={(e) => { setInvest((prev) => ({ ...prev, selectedRadio: e.target.value })) }}
                            >
                                <FormControlLabel value="test" control={<Radio size='small' disabled={props?.props?.patient_transfered || props?.props?.isLocked || props?.props?.isOPtometry} />} label={<Typography className='doc_notes_header_card_font'>Test</Typography>} />
                                <FormControlLabel value="special" control={<Radio size='small' disabled={props?.props?.patient_transfered || props?.props?.isLocked || props?.props?.isOPtometry} />} label={<Typography className='doc_notes_header_card_font'>Special</Typography>} />
                            </RadioGroup>
                            <Tooltip placement='top' arrow title={'Transfer'}><IconButton className='Common_Btn_Min_Width'
                                disabled={(invest.investigationData?.filter(item => item?.tst_name !== '')?.every(item => item?.is_transmitted)) || props?.props?.isOPtometry}
                                onClick={(e) => {e.stopPropagation(); postInvestigationTransmitData()}}
                            ><SyncAltIcon color={((invest.investigationData?.filter(item => item?.tst_name !== '')?.every(item => item?.is_transmitted)) || props?.props?.isOPtometry) ? 'disabled' : 'primary'} /></IconButton></Tooltip>
                            <Tooltip placement='top' arrow title={'Print'}>
                                <IconButton className='Common_Btn_Min_Width' emed_tid='prev_gls_prt'
                                    disabled={invest.printLoad}
                                    onClick={(e) => {e.stopPropagation(); setInvest((prev) => ({ ...prev, printLoad: true }))}}
                                ><PrintIcon color='primary' /></IconButton></Tooltip>
                        </Box>
                    </Box>
                    </AccordionSummary>
                    <AccordionDetails component={'div'} m={'0.5rem'}>
                        <Box component={'div'} border={'1px solid lightgray'}>
                            <Table size='small'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className='doc_notes_tbl_header'>Test Name</TableCell>
                                        <TableCell className='doc_notes_tbl_header'>Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {invest?.investigationData?.length > 0 ? invest?.investigationData?.map((item, index) => {
                                        return (
                                            <TableRow key={index}>
                                                <TableCell className='doc_notes_tbl_body_cell'>
                                                    {invest.selectedRadio === 'special' ?
                                                        autocompleteTextBox('special_test_name', item.tst_name, invest?.specialData, 'name', 'Special Test', index) :
                                                        autocompleteTextBox('test_name', item?.tst_name, invest?.labTestData, 'test_name', 'Select Test', index)}
                                                </TableCell>
                                                <TableCell className='doc_notes_tbl_body_cell'>
                                                    <Box component={'div'} display={'flex'} alignItems={'center'}>
                                                        <Typography className='doc_notes_header_card_font'>{item?.status}</Typography>
                                                        <IconButton sx={{ height: COMMON_STYLE.HEIGHT }} emed_tid='dlt_inv'
                                                            disabled={props?.props?.patient_transfered || props?.props?.isLocked || item?.is_transmitted || props?.props?.isOPtometry}
                                                            onClick={() => { deleteInvestigationData(item, index) }}
                                                        ><DeleteIcon color={(props?.props?.patient_transfered || props?.props?.isLocked || props?.props?.isOPtometry)? '' : 'error'} /></IconButton>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }) : <TableRow><TableCell align='center' colSpan={3}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
                                </TableBody>
                            </Table>
                        </Box>
                    </AccordionDetails>
                </Accordion>
                {
                    message.isErrorMsg ?
                        <ToastMsg
                            severity={'error'}
                            msg={message.isErrorMsgText}
                            msgPop={msgClose}
                        />
                        : null
                }
                {
                    message.successMsg ?
                        <ToastMsg
                            severity={'success'}
                            msg={message.successMsgText}
                            msgPop={msgClose}
                        />
                        : null
                }
            </Box >
        </ShowComponents>
    )
})

export default UmaInvestigationNew